import axios from 'axios'
import { createI18n } from 'vue-i18n'

import { TransientBaseObjectType } from '@/models/core/base'

import de from './lang-de'
import en from './lang-en'

export enum LocaleOption {
  EN = 'en',
  DE = 'de',
}

declare let process: {
  env: {
    NODE_ENV: string
  }
}

let silentTranslationWarn = true

const envVars = import.meta.env
if (envVars.NODE_ENV && envVars.NODE_ENV === 'development') {
  // This can be enabled during development to check for any missing translations
  silentTranslationWarn = true
}
const defaultLocale = LocaleOption.DE

// TODO: Default Language should be configurable by import.meta.env.DEFAULT_LANG or something
export const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'de',
  silentTranslationWarn,
  messages: {
    de,
    en,
  },
})
const loadedLanguages = ['de'] // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.global.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang: LocaleOption) {
  if (i18n.global.locale.value !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(`./lang-${lang}/index.ts`).then((msgs) => {
        i18n.global.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

export function getTranslation(text: string, plural: boolean = false) {
  if (plural) {
    return i18n.global.t(text, 2)
  } else {
    return i18n.global.t(text)
  }
}

export function createSuccessMessage(
  object: TransientBaseObjectType | string
): string {
  if (typeof object === 'string') {
    return `${object} ${i18n.global.t('components.common.createdSuccessfully')}`
  } else if (object.prettyName()) {
    return `${object.prettyName()} ${i18n.global.t(
      'components.common.createdSuccessfully'
    )}`
  } else {
    return i18n.global.t('components.common.createdSuccessfully')
  }
}
